export const GET_TRANSACTIONS_START = "GET_TRANSACTIONS_START";
export const GET_TRANSACTIONS_SUCCESS = "GET_TRANSACTIONS_SUCCESS";
export const GET_TRANSACTIONS_FAIL = "GET_TRANSACTIONS_FAIL";
export const APPROVE_TRANSACTION = "APPROVE_TRANSACTION";
export const EDIT_TRANSACTION = "EDIT_TRANSACTION";
export const DELETE_TRANSACTION = "DELETE_TRANSACTION";
export const CLEAR_TRANSACTIONS = "CLEAR_TRANSACTIONS";
export const DELETE_SEATS_TRANSACTION = "DELETE_SEATS_TRANSACTION";
